import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-select-search-input',
  templateUrl: './app-select-search-input.component.html',
  styleUrls: ['./app-select-search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSelectSearchInputComponent {
  @Input() placeholder: string;
  @Input() searchFormControl: UntypedFormControl;

  preventDefaultSpaceBehaviour(e: KeyboardEvent) {
    if (e && this.searchFormControl) {
      e.preventDefault();
      const searchVal = this.searchFormControl?.value || '';
      this.searchFormControl.setValue(searchVal + ' ');
      this.searchFormControl.updateValueAndValidity();
    }
  }
}
